"use client";

import { useLanguage } from "~/translations/loader/use-language";
import TeaserBarWrapper from "./teaserbar-wrapper-eon";
import { TeaserCard } from "./teasercard-eon";

export function TeaserBar() {
  const t = useLanguage();

  return (
    <TeaserBarWrapper
      // text-2xl base: at <lg the heading was 16px (Tailwind reset), making the
      // brand-red (4.17:1) fail AA normal-text contrast. >=24px bold qualifies as
      // large text (3:1), which the red passes — keeps the brand color.
      className="lg:!text-5xl font-bold text-2xl text-primary md:text-right md:text-4xl"
      headline={t.teaserbar_header}
    >
      <TeaserCard
        href={t.teaserbar_teaser1Link}
        imageSrc="images/teaserbar/teaser1_2026.webp"
        title={t.teaserbar_teaser1}
      />
      <TeaserCard
        href={t.teaserbar_teaser2Link}
        imageSrc="images/teaserbar/teaser2_2026.webp"
        title={t.teaserbar_teaser2}
      />
      <TeaserCard
        href={t.teaserbar_teaser3Link}
        imageSrc="images/teaserbar/teaser3_2026.webp"
        title={t.teaserbar_teaser3}
      />
    </TeaserBarWrapper>
  );
}
